var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3B99FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2993 11.9386C18.8203 8.46513 13.1797 8.46513 9.70069 11.9386L9.24112 12.3974C9.06717 12.5711 9.06717 12.8527 9.24112 13.0264L10.6734 14.4564C10.7604 14.5432 10.9014 14.5432 10.9884 14.4564L11.6054 13.8403C14.0325 11.4171 17.9675 11.4171 20.3945 13.8403L20.9707 14.4156C21.0577 14.5024 21.1987 14.5024 21.2857 14.4156L22.718 12.9856C22.8919 12.8119 22.8919 12.5303 22.718 12.3566L22.2993 11.9386ZM26.5362 16.1688L25.2614 14.896C25.0875 14.7224 24.8054 14.7224 24.6315 14.896L20.552 18.9691C20.5085 19.0125 20.438 19.0125 20.3945 18.9691L16.3149 14.896L16.3149 14.8959C16.1409 14.7223 15.8589 14.7223 15.6849 14.896L11.6055 18.9691C11.5621 19.0125 11.4916 19.0125 11.4481 18.9691L7.36846 14.896C7.19451 14.7223 6.91248 14.7223 6.73853 14.896L5.46378 16.1687C5.28983 16.3424 5.28983 16.6239 5.46378 16.7976L11.2119 22.5366C11.3858 22.7102 11.6679 22.7102 11.8418 22.5366L15.9213 18.4635C15.9648 18.4201 16.0353 18.4201 16.0788 18.4635L20.1583 22.5366C20.3323 22.7102 20.6143 22.7102 20.7882 22.5366L26.5362 16.7977C26.7101 16.624 26.7101 16.3424 26.5362 16.1688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnectIcon);
export default __webpack_public_path__ + "static/media/Walletconnect-icon.c1416ead2969053837cf88b7208d37fe.svg";
export { ForwardRef as ReactComponent };